export const DateFormat = {
  yyyyMMdd: 'yyyy-MM-dd',
} as const;

export type yyyyMMdd = 'yyyy-MM-dd';
